import React, {useState} from "react";
import styles from './SliderImage.module.css';

export default function SliderImage({cardsData}) {
    const [activeId, setActiveId] = useState(1);

    function onClick(id) {
        setActiveId(id)
    }

    const item = cardsData.map(card => (
        <div 
            className={`${styles.boxSlider} ${activeId === card.id ? styles.selected : ''}`} 
            key={card.id} 
            onClick={() => onClick(card.id)}
        >
            <img 
                src={card.url} 
                alt={card.title} 
                className={styles.sliderImage}
            />
            <p>{card.title}</p>
        </div>
    ))

    return (
        <div className={styles.sliderContainer}>
            {item}
        </div>
    )
}
